import { render, staticRenderFns } from "./ManageArticles.vue?vue&type=template&id=3785b0e4&scoped=true&"
import script from "./ManageArticles.vue?vue&type=script&lang=ts&"
export * from "./ManageArticles.vue?vue&type=script&lang=ts&"
import style0 from "./ManageArticles.vue?vue&type=style&index=0&id=3785b0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3785b0e4",
  null
  
)

export default component.exports